import React, { FC, useEffect } from 'react';
import { Skeleton } from 'antd';
import { getImproveQscStoreCardsCollection } from 'app/store/reducers/improveQsc.reducer';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { IImproveQscStoreCardsCollectionParams } from 'entities/ImproveQsc/ImproveQsc.models';
import { ImproveQscStoreCard } from 'entities/ImproveQsc/components/ImproveQscStoreCard';

interface IComponentProps {
  params: IImproveQscStoreCardsCollectionParams;
}

export const ImproveQscStoreCards: FC<IComponentProps> = ({ params }) => {
  const dispatch = useAppDispatch();

  const { improveQscStoreCardsCollection, improveQscStoreCardsCollectionLoading } = useAppSelector(
    (state) => state.improveQsc
  );

  const data = improveQscStoreCardsCollection?.data ?? [];

  useEffect(() => {
    dispatch(getImproveQscStoreCardsCollection(params));
  }, [params.storeCode, params.week]);

  return (
    <div className="iqsc-store-cards scrollbar-x">
      {improveQscStoreCardsCollectionLoading ? (
        <div className="flex iqsc-store-cards__container">
          <div className="p-5 iqsc-store-card">
            <Skeleton className="pb-5" active paragraph={{ rows: 4 }} title={false} />
            <Skeleton active paragraph={{ rows: 4 }} title={false} />
          </div>
          <div className="p-5 iqsc-store-card">
            <Skeleton className="pb-5" active paragraph={{ rows: 4 }} title={false} />
            <Skeleton active paragraph={{ rows: 4 }} title={false} />
          </div>
          <div className="p-5 iqsc-store-card">
            <Skeleton className="pb-5" active paragraph={{ rows: 4 }} title={false} />
            <Skeleton active paragraph={{ rows: 4 }} title={false} />
          </div>
        </div>
      ) : (
        <div className="flex iqsc-store-cards__container">
          {data.map((item) => {
            return <ImproveQscStoreCard key={item.storeCode} storeCard={item} />;
          })}
        </div>
      )}
    </div>
  );
};
